import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

const MobileScenario = () => {
  const navigate = useNavigate()
  const [currentStep, setCurrentStep] = useState(1)
  const [selectedChoice, setSelectedChoice] = useState(null)
  const [currentMoney, setCurrentMoney] = useState(400) // Track remaining money
  const [currentCredit, setCurrentCredit] = useState(0) // Track remaining credit

  const budget = 400.00 // Total budget for phone and credits

  const phoneOptions = [
    {
      id: 1,
      name: 'Lacný mobil',
      price: 220,
      creditIncluded: 30,
      quality: 'basic',
      description: 'Základné funkcie, normálny fotoaparát'
    },
    {
      id: 2,
      name: 'Stredný mobil',
      price: 300,
      creditIncluded: 30,
      quality: 'good',
      description: 'Dobrý fotoaparát, rýchly, väčší displej'
    },
    {
      id: 3,
      name: 'Drahý mobil',
      price: 380,
      creditIncluded: 20,
      quality: 'premium',
      description: 'Prémiový fotoaparát, najrýchlejší, veľký displej'
    }
  ]

  const handleRestart = () => {
    setCurrentStep(1)
    setSelectedChoice(null)
    setCurrentMoney(400)
    setCurrentCredit(0)
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-blue-50">
      
      {/* Header */}
      <div className="bg-gradient-to-r from-green-600 to-green-500 text-white py-8">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <div className="flex items-center justify-between">
              <div>
                <div className="text-sm font-medium text-green-100 mb-1">Interaktívny scenár</div>
                <h1 className="text-3xl font-bold">📱 Mobil a kredity</h1>
              </div>
              {currentStep === 1 ? (
                <button
                  onClick={() => navigate('/scenarios')}
                  className="px-4 py-2 bg-white/20 hover:bg-white/30 rounded-lg transition text-sm font-medium"
                >
                  ← Späť na ročníky
                </button>
              ) : (
                <button
                  onClick={() => setCurrentStep(currentStep - 1)}
                  className="px-4 py-2 bg-white/20 hover:bg-white/30 rounded-lg transition text-sm font-medium"
                >
                  ← Späť
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Progress indicator */}
      <div className="bg-white border-b border-gray-200 py-3">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <div className="flex items-center gap-1">
              {[...Array(17)].map((_, idx) => (
                <div
                  key={idx + 1}
                  className={`flex-1 h-2 rounded-full transition-all ${
                    idx + 1 <= currentStep ? 'bg-green-500' : 'bg-gray-200'
                  }`}
                />
              ))}
            </div>
            <p className="text-sm text-gray-600 mt-2 text-center">
              Krok {currentStep} z 17
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-3xl mx-auto">

          {/* Intro Slide 1: Question */}
          {currentStep === 1 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-8">
                <div className="text-6xl mb-4">💭</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  Čo je dôležitejšie pri kúpe mobilu?
                </h2>
              </div>

              <div className="space-y-4 max-w-2xl mx-auto">
                <div className="p-6 bg-blue-50 rounded-xl border-2 border-blue-200">
                  <div className="font-bold text-gray-800 mb-2">A) Mať najlepší mobil hneď teraz</div>
                  <p className="text-sm text-gray-600">Chcem najmodernejší telefón s najlepšími funkciami</p>
                </div>
                
                <div className="p-6 bg-green-50 rounded-xl border-2 border-green-200">
                  <div className="font-bold text-gray-800 mb-2">B) Mať peniaze aj na kredity celý rok</div>
                  <p className="text-sm text-gray-600">Chcem si nechať peniaze na kredity a prípadné opravy</p>
                </div>
              </div>

              <div className="text-center mt-8">
                <button
                  onClick={() => setCurrentStep(2)}
                  className="px-8 py-4 bg-green-600 text-white rounded-xl font-bold text-lg hover:bg-green-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Intro Slide 2: Discussion */}
          {currentStep === 2 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-5xl mb-4">💬</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                  Diskusia v triede
                </h2>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-lg max-w-2xl mx-auto">
                <h3 className="font-bold text-gray-900 mb-4">Zamyslite sa:</h3>
                <ul className="space-y-3 text-sm text-gray-700">
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold mt-1">•</span>
                    <span>Koľko peňazí potrebuješ mesačne na kredity?</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold mt-1">•</span>
                    <span>Čo sa stane, ak ti dôjdu kredity uprostred mesiaca?</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold mt-1">•</span>
                    <span>Môže sa ti mobil pokaziť? Budú peniaze na opravu?</span>
                  </li>
                </ul>
              </div>

              <div className="text-center mt-8">
                <button
                  onClick={() => setCurrentStep(3)}
                  className="px-8 py-4 bg-green-600 text-white rounded-xl font-bold text-lg hover:bg-green-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Intro Slide 3: Explanation */}
          {currentStep === 3 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 text-center">
              <div className="text-6xl mb-6">💡</div>
              <h2 className="text-2xl font-bold text-gray-900 mb-6">
                Dlhodobé plánovanie
              </h2>
              <div className="max-w-2xl mx-auto">
                <p className="text-lg text-gray-700 mb-4 leading-relaxed">
                  Mobil nie je len jednorazová kúpa. Potrebuješ aj kredity každý mesiac a niekedy aj opravu.
                </p>
                <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                  Rezerva peňazí ti pomôže zvládnuť nečakané výdavky. Plánuj vopred a mysli na celý rok, nie len na dnes.
                </p>
              </div>
              <button
                onClick={() => setCurrentStep(4)}
                className="px-8 py-4 bg-green-600 text-white rounded-xl font-bold text-lg hover:bg-green-700 transition shadow-lg"
              >
                Začať scenár
              </button>
            </div>
          )}

          {/* Step 4: Phone selection (merged Steps 2+3) */}
          {currentStep === 4 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">📱</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                  Ktorý mobil si kúpiš?
                </h2>
                <p className="text-gray-600 mb-6">
                  Máš k dispozícii: <span className="font-bold text-green-600 text-xl">400,00 €</span>
                </p>
              </div>

              <div className="space-y-4">
                {phoneOptions.map((phone) => (
                  <button
                    key={phone.id}
                    onClick={() => {
                      setSelectedChoice(phone)
                      setCurrentMoney(400 - phone.price)
                      setCurrentCredit(phone.creditIncluded)
                      setCurrentStep(5)
                    }}
                    className="w-full p-6 bg-gradient-to-r from-green-50 to-blue-50 rounded-xl border-2 border-green-200 hover:border-green-400 hover:shadow-lg transition-all text-left"
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        <span className="text-4xl">📱</span>
                        <div>
                          <div className="text-xl font-bold text-gray-800 mb-1">{phone.name}</div>
                          <div className="text-sm text-gray-600 mb-2">{phone.description}</div>
                          <div className="text-sm text-gray-700">
                            <span className="font-semibold text-blue-600">{phone.price},00 €</span>
                            <span className="text-gray-500"> + {phone.creditIncluded},00 € kredit v balíku</span>
                          </div>
                        </div>
                      </div>
                      <div className="text-right">
                        <div className="text-sm text-gray-500 mb-1">Zostane ti:</div>
                        <div className="text-2xl font-bold text-green-600">{(400 - phone.price).toFixed(2)} €</div>
                      </div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Step 5: Purchase result */}
          {currentStep === 5 && selectedChoice && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">📱</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                  Kúpil si: {selectedChoice.name}
                </h2>
              </div>

              <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-xl p-6 mb-6">
                <h3 className="font-bold text-gray-900 mb-4 text-center">Prehľad nákupu</h3>
                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-700">Začiatočný budget:</span>
                    <span className="font-bold text-blue-600">400,00 €</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-700">Cena mobilu:</span>
                    <span className="font-bold text-red-500">-{selectedChoice.price},00 €</span>
                  </div>
                  <div className="border-t border-gray-300 pt-3 flex justify-between items-center">
                    <span className="text-gray-900 font-bold">Zostáva ti:</span>
                    <span className="text-3xl font-bold text-green-600">{currentMoney.toFixed(2)} €</span>
                  </div>
                  <div className="border-t border-gray-300 pt-3 flex justify-between items-center">
                    <span className="text-gray-900 font-bold">Kredit v balíku:</span>
                    <span className="text-2xl font-bold text-purple-600">{currentCredit.toFixed(2)} €</span>
                  </div>
                </div>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-lg mb-6">
                <p className="text-gray-700 text-sm leading-relaxed">
                  {selectedChoice.quality === 'basic' && 'Máš základný mobil – funguje dobre, ale fotoaparát nie je veľmi dobrý. Zato ti zostalo viac peňazí.'}
                  {selectedChoice.quality === 'good' && 'Máš stredný mobil s dobrým fotoaparátom. Zostali ti ešte peniaze aj na ďalšie výdavky.'}
                  {selectedChoice.quality === 'premium' && 'Máš prémiový mobil s najlepším fotoaparátom! Ale zostalo ti už len málo peňazí.'}
                </p>
              </div>

              <div className="text-center">
                <button
                  onClick={() => setCurrentStep(6)}
                  className="px-8 py-4 bg-green-600 text-white rounded-xl font-bold text-lg hover:bg-green-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Step 6: Discussion #1 - Kompromisy */}
          {currentStep === 6 && selectedChoice && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-5xl mb-4">💬</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                  Diskusia: Kompromisy
                </h2>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-lg mb-6">
                <h3 className="font-bold text-gray-900 mb-3">Zamysli sa nad týmito otázkami:</h3>
                <ul className="space-y-3 text-sm text-gray-700">
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold mt-1">•</span>
                    <span>Prečo si si vybral práve tento mobil? Bola to kvalita mobilu alebo zostávajúce peniaze?</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold mt-1">•</span>
                    <span>Máš teraz {currentMoney.toFixed(2)} € a {currentCredit.toFixed(2)} € kredit. Bude ti to stačiť na nasledujúce mesiace?</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold mt-1">•</span>
                    <span>Čo keby si vybral iný mobil? Ako by sa zmenila tvoja situácia?</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold mt-1">•</span>
                    <span className="text-xs italic">💡 Niet správnej odpovede – každé rozhodnutie má svoje výhody a nevýhody.</span>
                  </li>
                </ul>
              </div>

              <div className="text-center">
                <button
                  onClick={() => setCurrentStep(7)}
                  className="px-8 py-4 bg-green-600 text-white rounded-xl font-bold text-lg hover:bg-green-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Step 7: First month credit usage */}
          {currentStep === 7 && selectedChoice && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">📅</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                  Prvý mesiac používania
                </h2>
              </div>

              <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-xl p-6 mb-6">
                <h3 className="font-bold text-gray-900 mb-3 text-center">Ako si minul kredity?</h3>
                <div className="space-y-2 text-sm text-gray-700">
                  <div className="flex justify-between">
                    <span>Volania rodičom a kamarátom:</span>
                    <span className="font-medium">-5,00 €</span>
                  </div>
                  <div className="flex justify-between">
                    <span>SMS správy:</span>
                    <span className="font-medium">-2,00 €</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Internet (sociálne siete, videá):</span>
                    <span className="font-medium">-8,00 €</span>
                  </div>
                  <div className="border-t border-gray-300 pt-2 flex justify-between font-bold">
                    <span>Celkovo minul si:</span>
                    <span className="text-red-500">-15,00 €</span>
                  </div>
                </div>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-lg mb-6">
                <p className="text-gray-700 leading-relaxed">
                  Z pôvodných <strong className="text-blue-600">{selectedChoice.creditIncluded},00 €</strong> kreditov ti zostáva{' '}
                  <strong className={selectedChoice.creditIncluded - 15 >= 10 ? 'text-green-600' : 'text-orange-600'}>
                    {(selectedChoice.creditIncluded - 15).toFixed(2)} €
                  </strong>.
                  {selectedChoice.creditIncluded - 15 >= 10 ? ' To je ešte dosť!' : ' To je už málo – budeš musieť šetriť alebo dokúpiť kredity.'}
                </p>
              </div>

              <div className="text-center">
                <button
                  onClick={() => {
                    setCurrentCredit(selectedChoice.creditIncluded - 15)
                    setCurrentStep(8)
                  }}
                  className="px-8 py-4 bg-green-600 text-white rounded-xl font-bold text-lg hover:bg-green-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Step 8: Credit status + optional top-up */}
          {currentStep === 8 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">💳</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                  Potrebuješ dokúpiť kredity?
                </h2>
              </div>

              <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-xl p-6 mb-6">
                <div className="grid grid-cols-2 gap-6 text-center">
                  <div>
                    <div className="text-sm text-gray-600 mb-1">Peniaze</div>
                    <div className="text-3xl font-bold text-green-600">{currentMoney.toFixed(2)} €</div>
                  </div>
                  <div>
                    <div className="text-sm text-gray-600 mb-1">Kredit</div>
                    <div className="text-3xl font-bold text-purple-600">{currentCredit.toFixed(2)} €</div>
                  </div>
                </div>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-lg mb-6">
                <p className="text-gray-700 text-sm">
                  Kredity stoja <strong>20 € za balík</strong>. Môžeš si dokúpiť, ak chceš mať rezervu.
                </p>
              </div>

              {currentMoney >= 20 ? (
                <div className="space-y-4">
                  <button
                    onClick={() => {
                      setCurrentMoney(currentMoney - 20)
                      setCurrentCredit(currentCredit + 20)
                      setCurrentStep(9)
                    }}
                    className="w-full p-4 bg-gradient-to-r from-purple-50 to-blue-50 rounded-xl border-2 border-purple-200 hover:border-purple-400 hover:shadow-lg transition-all text-left"
                  >
                    <div className="font-bold text-gray-800 mb-1">
                      Dokúpiť 20 € kredit
                    </div>
                    <div className="text-sm text-gray-600">
                      Zostane ti {(currentMoney - 20).toFixed(2)} € a budeš mať {(currentCredit + 20).toFixed(2)} € kredit
                    </div>
                  </button>

                  <button
                    onClick={() => setCurrentStep(9)}
                    className="w-full p-4 bg-gradient-to-r from-gray-50 to-gray-100 rounded-xl border-2 border-gray-200 hover:border-gray-400 hover:shadow-lg transition-all text-left"
                  >
                    <div className="font-bold text-gray-800 mb-1">
                      Nedokupovať
                    </div>
                    <div className="text-sm text-gray-600">
                      Ušetríš peniaze, ale možno ti nebude stačiť kredit
                    </div>
                  </button>
                </div>
              ) : (
                <div>
                  <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-lg mb-6">
                    <p className="text-gray-700 leading-relaxed">
                      <strong>Nemáš dosť peňazí.</strong> Potrebuješ 20 €, ale máš len {currentMoney.toFixed(2)} €.
                      {selectedChoice && selectedChoice.price >= 300 ? (
                        <> Nemôžeš si dokúpiť kredity – minul si príliš veľa na mobil.</>
                      ) : (
                        <> Minul si už všetky zostávajúce peniaze.</>
                      )}
                    </p>
                  </div>
                  <div className="text-center">
                    <button
                      onClick={() => setCurrentStep(9)}
                      className="px-8 py-4 bg-orange-600 text-white rounded-xl font-bold text-lg hover:bg-orange-700 transition"
                    >
                      Pokračovať
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Step 9: Discussion #2 - Planning */}
          {currentStep === 9 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-5xl mb-4">💬</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                  Diskusia: Plánovanie
                </h2>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-lg mb-6">
                <h3 className="font-bold text-gray-900 mb-3">Zamysli sa:</h3>
                <ul className="space-y-3 text-sm text-gray-700">
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold mt-1">•</span>
                    <span>Koľko kreditov potrebuješ mesačne? 15 € mesačne znamená 180 € ročne!</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold mt-1">•</span>
                    <span>Aké rozhodnutie si urobil pri výbere mobilu? Čo to znamená pre tvoj rozpočet na celý rok?</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold mt-1">•</span>
                    <span>Teraz máš {currentMoney.toFixed(2)} € a {currentCredit.toFixed(2)} € kredit. Vystačí ti to na ďalší mesiac?</span>
                  </li>
                </ul>
              </div>

              <div className="text-center">
                <button
                  onClick={() => setCurrentStep(10)}
                  className="px-8 py-4 bg-green-600 text-white rounded-xl font-bold text-lg hover:bg-green-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Step 10: Following months summary */}
          {currentStep === 10 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">📅</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                  Ďalšie 2 mesiace
                </h2>
                <p className="text-gray-600">Druhý a tretí mesiac</p>
              </div>

              <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-xl p-6 mb-6">
                <h3 className="font-bold text-gray-900 mb-3 text-center">Mesačné náklady</h3>
                <div className="space-y-2 text-sm text-gray-700 mb-4">
                  <div className="flex justify-between">
                    <span>Druhý mesiac (kredity):</span>
                    <span className="font-medium text-red-600">-15,00 €</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Tretí mesiac (kredity):</span>
                    <span className="font-medium text-red-600">-15,00 €</span>
                  </div>
                  <div className="border-t border-gray-300 pt-2 flex justify-between font-bold">
                    <span>Spolu minul si:</span>
                    <span className="text-red-600">-30,00 €</span>
                  </div>
                </div>
                
                <div className="bg-white rounded-lg p-4 border-2 border-blue-200">
                  <div className="text-center mb-2">
                    <div className="text-xs text-gray-600 mb-1">Kredit po 3 mesiacoch:</div>
                    <div className={`text-2xl font-bold ${currentCredit - 30 >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                      {Math.max(0, currentCredit - 30).toFixed(2)} €
                    </div>
                  </div>
                  <div className="text-center">
                    <div className="text-xs text-gray-600">Peniaze: <strong>{currentMoney.toFixed(2)} €</strong></div>
                  </div>
                </div>
              </div>

              {currentCredit - 30 < 0 && (
                <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-lg mb-6">
                  <p className="text-gray-700 text-sm">
                    <strong>⚠️ Problém!</strong> Kredit ti nedostačoval! Musel si požiadať rodičov o pomoc.
                  </p>
                </div>
              )}

              {currentCredit - 30 >= 0 && (
                <div className="bg-green-50 border-l-4 border-green-400 p-4 rounded-lg mb-6">
                  <p className="text-gray-700 text-sm">
                    ✅ Kredity ti stačili na ďalšie 2 mesiace!
                  </p>
                </div>
              )}

              <div className="text-center">
                <button
                  onClick={() => {
                    setCurrentCredit(Math.max(0, currentCredit - 30))
                    setCurrentStep(11)
                  }}
                  className="px-8 py-4 bg-green-600 text-white rounded-xl font-bold text-lg hover:bg-green-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Step 11: Broken phone + repair decision (merged) */}
          {currentStep === 11 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">💥</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                  Nečakaná udalosť!
                </h2>
                <p className="text-gray-600">Mobil ti spadol a pokazil sa displej</p>
              </div>

              <div className="bg-red-50 border-l-4 border-red-400 p-6 rounded-lg mb-6">
                <p className="text-gray-700 mb-3">
                  <strong>Pokazený mobil!</strong> Displej je popraskané. Mobil funguje, ale je ťažko čitateľný.
                  Oprava stojí <strong className="text-red-600">55 €</strong>.
                </p>
                <div className="bg-white rounded-lg p-3 mt-3">
                  <div className="grid grid-cols-2 gap-4 text-center">
                    <div>
                      <div className="text-xs text-gray-600">Peniaze</div>
                      <div className="text-lg font-bold text-green-600">{currentMoney.toFixed(2)} €</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-600">Kredit</div>
                      <div className="text-lg font-bold text-blue-600">{currentCredit.toFixed(2)} €</div>
                    </div>
                  </div>
                </div>
              </div>

              <h3 className="font-bold text-gray-900 mb-4 text-center">Čo urobíš?</h3>

              <div className="space-y-4">
                {currentMoney >= 55 ? (
                  <>
                    <button
                      onClick={() => {
                        setCurrentMoney(currentMoney - 55)
                        setSelectedChoice({...selectedChoice, repaired: true})
                        setCurrentStep(12)
                      }}
                      className="w-full p-4 bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl border-2 border-blue-200 hover:border-blue-400 hover:shadow-lg transition-all text-left"
                    >
                      <div className="font-bold text-gray-800 mb-1">
                        🔧 Opraviť mobil (55 €)
                      </div>
                      <div className="text-sm text-gray-600">
                        Zostane ti {(currentMoney - 55).toFixed(2)} €, ale budeš mať funkčný mobil
                      </div>
                    </button>

                    <button
                      onClick={() => {
                        setSelectedChoice({...selectedChoice, repaired: false})
                        setCurrentStep(12)
                      }}
                      className="w-full p-4 bg-gradient-to-r from-gray-50 to-gray-100 rounded-xl border-2 border-gray-200 hover:border-gray-400 hover:shadow-lg transition-all text-left"
                    >
                      <div className="font-bold text-gray-800 mb-1">
                        ❌ Neopraviť – používať pokazený
                      </div>
                      <div className="text-sm text-gray-600">
                        Ušetríš peniaze, ale mobil bude ťažko čitateľný
                      </div>
                    </button>
                  </>
                ) : (
                  <button
                    onClick={() => {
                      setSelectedChoice({...selectedChoice, repaired: false, notEnoughMoney: true})
                      setCurrentStep(12)
                    }}
                    className="w-full p-4 bg-red-50 rounded-xl border-2 border-red-300 text-left"
                  >
                    <div className="font-bold text-gray-800 mb-1">
                      😞 Nemám dosť peňazí na opravu
                    </div>
                    <div className="text-sm text-gray-600">
                      Potrebuješ 55 €, ale máš len {currentMoney.toFixed(2)} €
                    </div>
                  </button>
                )}
              </div>
            </div>
          )}

          {/* Step 12: Repair outcome */}
          {currentStep === 12 && selectedChoice && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">
                  {selectedChoice.repaired ? '✅' : '📱'}
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                  Výsledok tvojho rozhodnutia
                </h2>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-lg mb-6">
                <p className="text-gray-700 leading-relaxed">
                  {selectedChoice.notEnoughMoney ? (
                    <>
                      Nemal si dosť peňazí na opravu. Budeš musieť používať pokazený mobil alebo požiadať rodičov o pomoc.
                      {selectedChoice.price >= 300 ? (
                        <> To je dôsledok toho, že si minul viac peňazí na mobil na začiatku.</>
                      ) : (
                        <> Minul si už peniaze na iné veci. Výdavky treba plánovať.</>
                      )}
                    </>
                  ) : selectedChoice.repaired ? (
                    <>Opravil si mobil za 55 €. Teraz máš funkčný mobil, ale zostáva ti už len {currentMoney.toFixed(2)} €. Oprava bola drahá, ale aspoň máš opäť poriadny displej.</>
                  ) : (
                    <>Rozhodol si sa neopraviť mobil. Displej je prasklý, ale mobil funguje. Nie je to ideálne, ale ušetril si 55 € a máš stále {currentMoney.toFixed(2)} €.</>
                  )}
                </p>
              </div>

              <div className="text-center">
                <button
                  onClick={() => setCurrentStep(14)}
                  className="px-8 py-4 bg-green-600 text-white rounded-xl font-bold text-lg hover:bg-green-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Step 13: Optional credit top-up after repair */}
          {currentStep === 13 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">💳</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                  Potrebuješ ešte kredity?
                </h2>
              </div>

              <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-xl p-6 mb-6">
                <div className="grid grid-cols-2 gap-6 text-center">
                  <div>
                    <div className="text-sm text-gray-600 mb-1">Peniaze</div>
                    <div className="text-3xl font-bold text-green-600">{currentMoney.toFixed(2)} €</div>
                  </div>
                  <div>
                    <div className="text-sm text-gray-600 mb-1">Kredit</div>
                    <div className="text-3xl font-bold text-purple-600">{currentCredit.toFixed(2)} €</div>
                  </div>
                </div>
              </div>

              {currentMoney >= 20 ? (
                <div className="space-y-4">
                  <button
                    onClick={() => {
                      setCurrentMoney(currentMoney - 20)
                      setCurrentCredit(currentCredit + 20)
                      setCurrentStep(14)
                    }}
                    className="w-full p-4 bg-gradient-to-r from-purple-50 to-blue-50 rounded-xl border-2 border-purple-200 hover:border-purple-400 hover:shadow-lg transition-all text-left"
                  >
                    <div className="font-bold text-gray-800 mb-1">
                      Dokúpiť 20 € kredit
                    </div>
                    <div className="text-sm text-gray-600">
                      Zostane ti {(currentMoney - 20).toFixed(2)} € a budeš mať {(currentCredit + 20).toFixed(2)} € kredit
                    </div>
                  </button>

                  <button
                    onClick={() => setCurrentStep(14)}
                    className="w-full p-4 bg-gradient-to-r from-gray-50 to-gray-100 rounded-xl border-2 border-gray-200 hover:border-gray-400 hover:shadow-lg transition-all text-left"
                  >
                    <div className="font-bold text-gray-800 mb-1">
                      Nedokupovať
                    </div>
                    <div className="text-sm text-gray-600">
                      Ušetríš peniaze
                    </div>
                  </button>
                </div>
              ) : (
                <div>
                  <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-lg mb-6">
                    <p className="text-gray-700">
                      <strong>Nemáš dosť peňazí.</strong> Potrebuješ 20 €, ale máš len {currentMoney.toFixed(2)} €.
                    </p>
                  </div>
                  <div className="text-center">
                    <button
                      onClick={() => setCurrentStep(14)}
                      className="px-8 py-4 bg-orange-600 text-white rounded-xl font-bold text-lg hover:bg-orange-700 transition"
                    >
                      Pokračovať
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Step 14: Discussion #3 - Unexpected expenses */}
          {currentStep === 14 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-5xl mb-4">💬</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                  Diskusia: Nečakané výdavky
                </h2>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-lg mb-6">
                <h3 className="font-bold text-gray-900 mb-3">Zamysli sa:</h3>
                <ul className="space-y-3 text-sm text-gray-700">
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold mt-1">•</span>
                    <span>Oprava mobilu stála 55 €. To je veľa! Mal si dosť peňazí alebo si musel použiť všetko?</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold mt-1">•</span>
                    <span>Rezerva peňazí pomáha zvládnuť nečakané výdavky. Je dôležité mať peniaze aj na opravy.</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold mt-1">•</span>
                    <span>Nečakané výdavky sa stávajú – preto je dôležité mať rezervu.</span>
                  </li>
                </ul>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-lg mb-6">
                <p className="text-gray-700 text-sm">
                  <strong>💡 Pre diskusiu:</strong> Koľko percent z 400 € by si mal mať ako "bezpečnostnú rezervu" na nečakané výdavky?
                </p>
              </div>

              <div className="text-center">
                <button
                  onClick={() => setCurrentStep(15)}
                  className="px-8 py-4 bg-green-600 text-white rounded-xl font-bold text-lg hover:bg-green-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Step 15: Annual summary */}
          {currentStep === 15 && selectedChoice && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">📊</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                  Finálna situácia po 3 mesiacoch
                </h2>
                <p className="text-gray-600 mt-2">Takto vyzerajú tvoje rozhodnutia po 3 mesiacoch.</p>
              </div>

              <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-xl p-6 mb-6">
                <h3 className="font-bold text-gray-900 mb-4 text-center">Prehľad všetkých transakcií</h3>
                <div className="space-y-3 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-700">Začiatočný budget:</span>
                    <span className="font-bold text-blue-600">400,00 €</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-700">Mobil ({selectedChoice.name}):</span>
                    <span className="font-bold text-red-500">-{selectedChoice.price},00 €</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-700">Kredity v balíku:</span>
                    <span className="font-bold text-green-600">+{selectedChoice.creditIncluded},00 €</span>
                  </div>
                  {selectedChoice.repaired && (
                    <div className="flex justify-between">
                      <span className="text-gray-700">Oprava displeja:</span>
                      <span className="font-bold text-red-500">-55,00 €</span>
                    </div>
                  )}
                  <div className="border-t border-gray-300 pt-3">
                    <div className="flex justify-between font-bold text-lg">
                      <span>Zostávajúce peniaze:</span>
                      <span className="text-green-600">{currentMoney.toFixed(2)} €</span>
                    </div>
                    <div className="flex justify-between font-bold text-lg mt-2">
                      <span>Zostávajúci kredit:</span>
                      <span className="text-purple-600">{currentCredit.toFixed(2)} €</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-center">
                <button
                  onClick={() => setCurrentStep(16)}
                  className="px-8 py-4 bg-green-600 text-white rounded-xl font-bold text-lg hover:bg-green-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Step 16: Combined lessons and reflection */}
          {currentStep === 16 && selectedChoice && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">📚</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                  Čo si sa naučil?
                </h2>
              </div>

              {/* Key Lessons */}
              <div className="space-y-4 mb-8">
                <div className="bg-blue-50 border-l-4 border-blue-400 p-5 rounded-lg">
                  <h3 className="font-bold text-gray-900 mb-2">1. Plánovanie budgetu</h3>
                  <p className="text-gray-700 text-sm">
                    Mobil nie je len jednorazová kúpa – musíš počítať aj s mesačnými nákladmi na kredity. Z 400 € ti zostalo {currentMoney.toFixed(2)} €.
                  </p>
                </div>

                <div className="bg-blue-50 border-l-4 border-blue-400 p-5 rounded-lg">
                  <h3 className="font-bold text-gray-900 mb-2">2. Mesačné náklady sa spočítajú</h3>
                  <p className="text-gray-700 text-sm">
                    15 € mesačne vyzerá málo, ale za rok je to 180 €! To je takmer polovica ceny mobilu.
                  </p>
                </div>

                <div className="bg-blue-50 border-l-4 border-blue-400 p-5 rounded-lg">
                  <h3 className="font-bold text-gray-900 mb-2">3. Neočakávané výdavky</h3>
                  <p className="text-gray-700 text-sm">
                    Oprava displeja (55 €) bola veľký výdavok. Veci sa kazia – preto je dôležité mať rezervu.
                  </p>
                </div>

                <div className="bg-blue-50 border-l-4 border-blue-400 p-5 rounded-lg">
                  <h3 className="font-bold text-gray-900 mb-2">4. Kompromisy</h3>
                  <p className="text-gray-700 text-sm">
                    Drahší mobil = lepšia kvalita, ale menej peňazí. Lacnejší mobil = viac peňazí na kredity a opravy. Každé rozhodnutie má výhody aj nevýhody.
                  </p>
                </div>

                <div className="bg-blue-50 border-l-4 border-blue-400 p-5 rounded-lg">
                  <h3 className="font-bold text-gray-900 mb-2">5. Dlhodobé vs. krátkodobé potreby</h3>
                  <p className="text-gray-700 text-sm">
                    Prémiový fotoaparát je pekný teraz, ale kredity potrebuješ každý mesiac. Niekedy je lepšie vybrať si praktickejšiu možnosť.
                  </p>
                </div>
              </div>

              {/* Reflection */}
              <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-xl p-6 mb-6">
                <h3 className="font-bold text-gray-900 mb-3">Tvoje rozhodnutia:</h3>
                <ul className="space-y-2 text-sm text-gray-700">
                  <li>• <strong>Začiatok:</strong> Dostal si 400,00 € na mobil</li>
                  <li>• <strong>Kúpil si:</strong> {selectedChoice.name} za {selectedChoice.price},00 € (+ {selectedChoice.creditIncluded}€ kredit)</li>
                  <li>• <strong>Kredity za 3 mesiace:</strong> Minul si 45,00 € (15€/mesiac)</li>
                  <li>• <strong>Oprava:</strong> {
                    selectedChoice.notEnoughMoney ? 'Nemal si dosť peňazí na opravu (55€)' :
                    selectedChoice.repaired ? 'Opravil si mobil za 55 €' : 
                    'Neopravil si mobil, ušetril si 55 €'
                  }</li>
                  <li>• <strong>Nakoniec ti zostalo:</strong> {currentMoney.toFixed(2)} € a {currentCredit.toFixed(2)} € kredit</li>
                </ul>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-lg mb-6">
                <p className="text-gray-700 text-sm leading-relaxed">
                  <strong>💡 Zamysli sa:</strong> Čo by si urobil inak? Kúpil by si lacnejší mobil a mal viac peňazí na kredity a opravy?
                </p>
              </div>

              <div className="text-center">
                <button
                  onClick={() => setCurrentStep(17)}
                  className="px-8 py-4 bg-green-600 text-white rounded-xl font-bold text-lg hover:bg-green-700 transition"
                >
                  Dokončiť scenár
                </button>
              </div>
            </div>
          )}

          {/* Step 17: Completion */}
          {currentStep === 17 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 text-center">
              <div className="text-6xl mb-6">🎉</div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Scenár dokončený!
              </h2>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                Skvelá práca! Naučil si sa dôležité lekcie o prioritách, plánovaní a neočakávaných výdavkoch.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button
                  onClick={handleRestart}
                  className="px-8 py-4 bg-green-600 text-white rounded-xl font-bold text-lg hover:bg-green-700 transition shadow-lg"
                >
                  🔄 Skúsiť znova
                </button>
                <button
                  onClick={() => navigate('/scenarios')}
                  className="px-8 py-4 bg-gray-100 text-gray-700 rounded-xl font-bold text-lg hover:bg-gray-200 transition"
                >
                  ← Späť na ročníky
                </button>
              </div>

              <div className="mt-8 p-6 bg-blue-50 rounded-xl">
                <p className="text-sm text-gray-700">
                  <strong>Ďalší scenár:</strong> Vyskúšaj scenár "Školský bufet" pre ďalšie finančné rozhodovanie!
                </p>
              </div>
            </div>
          )}

        </div>
      </div>

    </div>
  )
}

export default MobileScenario
